import React from 'react'
import { asJSONSafe } from '../../functions'
import { toUIDate, toUIDateTime } from '../../functions/dateHelpers';

export const mappingSchema = [
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'adress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'organization_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetObject.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_obtaining_place', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarding_organizations', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchMaterial', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchMaterial', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'probe_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'place_of_selection', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_org_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'samplingLocation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'forwarder_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'applicant_full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.phoneNumber', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'contact_number', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'full_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.identityNumber', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'iin', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.yearsOld', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'age', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.placeOfWorkOrEducation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'place_of_work', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.placeOfWorkOrEducation', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'work_place', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'home_adress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'selection_date', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleSelectionTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_obtaining_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'probe_delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'nd_on_research_method', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_selection', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'standard2', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_measurements', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'transportationCondition.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'transport_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'sampleCollectedFullName', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'material_forwarder', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'storageCondition.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'storage_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'purposeOfSelection.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researchPurpose', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'researcherStatus1', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'objectReferral', // objectReferral or act
        sourceMember: 'purposeOfSelection.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'examination_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    ///////////acts
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'object.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'adress', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'selectionDateTime.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'selection_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'deliveryDateTime.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'delivery_date', //the name of field from targetObject
        targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'data.selectionDateTime.value', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        sourceMemberMap: _ => {
            const d = toUIDateTime(_);
            return d;
       }, 
        targetMember: 'sampleSelectionTime', //the name of field from targetObject
   //     targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'data.deliveryDateTime.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            const d = toUIDateTime(_);
            return d;
       },
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sampleDeliveryTime', //the name of field from targetObject
   //     targetMemberType: 'date',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'nd_on_research_method', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_selection', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'standard.value', //the name of field from objectReferral or act
        sourceMemberMap: _ => {
            _ = asJSONSafe(_);
            return _?.map(i => i?.name).join(', ');
        },
        targetType: 'protocol', // result or protocol
        targetMember: 'normative_document_measurements', //the name of field from targetObject
        targetMemberType: 'array',
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'object.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'organization_name', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filial', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filial', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filialId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filialId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filialDivision', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filialDivision', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'filialDivisionId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'filialDivisionId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilialDivisionId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilialDivisionId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilialDivision', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilialDivision', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilialId', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilialId', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'sourceFilial', //the name of field from objectReferral or act
        targetType: 'objectReferral', // result or protocol
        targetMember: 'sourceFilial', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'selectionPlace.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'sample_obtaining_place', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'selectionPlace.value', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'place_of_selection', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'samplingPurpose.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goal', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'samplingPurpose.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'research_goals', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'transportationCondition.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'transport_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'storageCondition.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'storage_conditions', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
    {
        sourceType: 'act', // objectReferral or act
        sourceMember: 'preservationMethod.value.name', //the name of field from objectReferral or act
        targetType: 'protocol', // result or protocol
        targetMember: 'water_conservation_methods', //the name of field from targetObject
        targetNumber: '', // the number of target itself (can be empty)
    },
///////////results
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'number', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'registrationNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'surnameNamePatronymicPatientMedicalRecordNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'thePersonBeingInspected', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'surnameNamePatronymicIfAnyOfTheSubject', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty) surnameNamePatronymicIfAnyOfTheSubject
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetObject.name', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'organizationSubmittingTheSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'nameOfTheSendingOrganization', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'theOrganizationThatSentTheSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.placeOfWorkOrEducation', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'placeOfWorkPosition', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'data.diagnosis', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'diagnosisDateOfIllness', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.yearsOld', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'age', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'homeAddress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'residentialAddress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchMaterial', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'testSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchMaterial', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'sampleName', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchMaterial', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'modelName', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchPurpose', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'purposeOfTheStudy', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchPurpose', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'thePurposeOfTheStudy', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researcherStatus1', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'thePurposeOfTheStudy', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchStartDateTime', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'dateOfStudy', //the name of field from targetObject
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },    
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'researchEndDateTime', //the name of field from objectReferral or act
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },
    targetType: 'result', // result or protocol
    targetMember: 'dateOfStudyCompletion', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleDeliveryTime', //the name of field from objectReferral or act
    sourceMemberMap: _ => {
         const d = toUIDate(_);
         return d;
    },
    targetType: 'result', // result or protocol
    targetMember: 'receiptDate', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'institutionThatSentTheSample', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'objectReferral', // objectReferral or act
    sourceMember: 'samplingLocation', //the name of field from objectReferral or act
    targetType: 'result', // result or protocol
    targetMember: 'samplingLocation', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
/////////////////////////resultProtocol
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'theResultsOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_results', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'researchResult', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_results', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'researchResult', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'complied_with_regulatory_doc', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'purposeOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_goal', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'purposeOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'research_goals', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'diagnosis', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'diagnosis', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'result', // objectReferral or act
    sourceMember: 'dateMonthYearOfTheStartOfTheStudy', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'sample_delivery_date', //the name of field from targetObject dateMonthYearOfStudyCompletion
    targetNumber: '', // the number of target itself (can be empty)
    targetMemberType: 'date'
},
///////////////////prescriptions
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'number', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'emergencyNotificationNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'targetDate', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    sourceMemberMap: _ => {
        const d = toUIDate(_);
        return d;
   },
    targetMember: 'emergencyNotificationDate', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'targetObject', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'targetObject', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'targetObjectId', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'targetObjectId', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'standards', //the name of field from objectReferral or act
    sourceMemberMap: _ => asJSONSafe(_),
    targetType: 'objectReferral', // result or protocol
    targetMember: 'standard2', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'prescription', // objectReferral or act
    sourceMember: 'regulationOfCUs', //the name of field from objectReferral or act
    sourceMemberMap: _ => asJSONSafe(_),
    targetType: 'objectReferral', // result or protocol
    targetMember: 'regulationOfCU2', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
////////////////resolutions
{
    sourceType: 'resolution', // objectReferral or act
    sourceMember: 'number', //the name of field from objectReferral or act
    targetType: 'objectReferral', // result or protocol
    targetMember: 'emergencyNotificationNumber', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
/////////////////////referrals
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.fullName', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'examinatee_full_name', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'diagnosis', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'diagnosis', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.yearsOld', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'age', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'adress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (can be empty)
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'targetPatient.addressLine', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'adress', //the name of field from targetObject
    targetNumber: '', // the number of target itself (sampleSentOrganizationName
},
{
    sourceType: 'referral', // objectReferral or act
    sourceMember: 'sampleSentOrganizationName', //the name of field from objectReferral or act
    targetType: 'protocol', // result or protocol
    targetMember: 'organization_name', //the name of field from targetObject
    targetNumber: '', // the number of target itself (sampleSentOrganizationName
}
]

